module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 536
// module chunks = 0